import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import Radium from 'radium';
import Axios from 'axios';
import queryString from 'query-string';
import {
	ListGroup,
	ListGroupItem,
	ListGroupItemHeading,
	ListGroupItemText,
	Button,
} from 'reactstrap';

import ArrowIcon from '../icons/RightArrow';
import GenModal from './GenModal';

class StatusList extends Component {
	state = {
		redirect: false,
	};

	setCallback = (object) => {
		this.props.callbackFromParent(object);
	};

	setName = (object) => {
		this.props.callbackName(object);
	};

	setDiv = (object) => {
		this.props.callbackDiv(object);
	};

	setAudience_id = (object) => {
		this.props.callbackAudience(object);
	};

	setLeave = (object) => {
		this.props.setLeave(object);
	};

	setOffline = (offline) => {
		this.props.setOffline(offline);
	};

	addBallotLoaded = () => {
		this.props.addBallotLoaded();
	};

	clearBallotLoaded = () => {
		this.props.clearBallotLoaded();
	};

	handleOnClick = (index) => {
		this.clearBallotLoaded();
		var url = '';
		if (this.props.list[index].type === 'nomination') {
			url = 'https://hcapps.holycross.edu/faculty_elections_admin/nomination_candidates?';
		} else if (this.props.list[index].type === 'election') {
			url = 'https://hcapps.holycross.edu/faculty_elections_admin/election_candidates?';
		}
		var args = {
			audience_id: this.props.list[index].id,
			email: this.props.email,
			division: this.props.list[index].division_department,
		};
		var query = queryString.stringify(args, { encode: false });
		var path = url + query;
		Axios({
			method: 'get',
			url: path,
			timeout: 5000,
			headers: { AUTHKEY: sessionStorage.getItem('FECaccessToken') },
		})
			.then((res) => {
				console.log('successfully queried for candidates');
				this.setCallback(res.data);
				sessionStorage.setItem('FECballot', JSON.stringify(res.data));
				this.setName(this.props.list[index].display_text);
				sessionStorage.setItem('FECballotTitle', this.props.list[index].display_text);
				this.setDiv(this.props.list[index].division_department);
				sessionStorage.setItem('FECdivTitle', this.props.list[index].division_department);
				this.setAudience_id(this.props.list[index].id);
				sessionStorage.setItem('FECaudience_id', this.props.list[index].id);
				this.setOffline(false);
				this.addBallotLoaded();
			})
			.catch((error) => {
				console.error('error querying for candidates: ', error);
				this.setOffline(true);
			});
		args = {
			election_id: this.props.list[index].election_id,
			audience_id: this.props.list[index].id,
		};
		query = queryString.stringify(args, { encode: false });
		url = 'https://hcapps.holycross.edu/faculty_elections_admin/legend?';
		path = url + query;
		Axios({ method: 'get', url: path, timeout: 5000, headers: { AUTHKEY: this.state.accessToken } })
			.then((res) => {
				console.log('successfully queried for leave legend');
				this.setLeave(res.data);
				sessionStorage.setItem('FECleave', JSON.stringify(res.data));
				this.setOffline(false);
				this.addBallotLoaded();
			})
			.catch((error) => {
				console.error('error querying for leave legend', error);
				this.setOffline(true);
			});
		this.setState({ redirect: true });
	};

	divisionFormat = (division) => {
		if (division.length === 1) {
			return <>Division: {division}</>;
		} else {
			return <>{division}</>;
		}
	};

	formatSelected = (audience) => {
		if (!(this.props.list === undefined)) {
			const formattedArray = [];
			audience.selected.forEach((name) => {
				var entry = ' ';
				entry = entry.concat(name.name);
				formattedArray.push(entry);
			});
			return formattedArray;
		}
		return null;
	};

	generateList = () => {
		if (!(this.props.list === undefined)) {
			const List = this.props.list.map((division, index) => {
				return (
					<ListGroupItem
						className="list-group-item-action"
						style={itemStyle}
						key={index}
						onClick={() => this.handleOnClick(index)}
					>
						<div>
							{(division.rule === "Statute" && division.number_selected === 0) ? (
        				<ListGroupItemHeading>Please click here to continue to the ballot</ListGroupItemHeading>
	    				) : (division.rule === "Statute") ? (
        				<ListGroupItemHeading>Please click "cast ballot" to complete your vote</ListGroupItemHeading>
							) : (
        				<ListGroupItemHeading>{division.display_text}</ListGroupItemHeading>
      				)}
							
							<ListGroupItemText>
								{this.divisionFormat(division.division_department)}
							</ListGroupItemText>
							<ListGroupItemText>
								<small>
									{division.selected.length > 0 ? 'Selected: ' : ''}
									{division.rule === 'Statute' || division.selected.length > 0 ? '' : 'Abstain'}
									{this.formatSelected(division).toString()}
								</small>
							</ListGroupItemText>
							<small>
								<i className="text-uppercase">
									{division.number_selected}/{division.number_to_select}
								</i>
							</small>
						</div>
						<div style={iconBlockStyle}>
							<ArrowIcon width="32px" height="32px" />
						</div>
					</ListGroupItem>
				);
			});
			return List;
		}
		return null;
	};

	componentDidMount() {
		window.scrollTo(0, 0);
		this.props.callbackClearChoices();
		this.props.callbackClearBallot();
	}

	render() {
		if (this.state.redirect) {
			return <Redirect push to="/ballot" />;
		}
		return (
			<div style={boxStyle}>
				<h2 style={titleStyle}>{this.props.title}</h2>
				<ListGroup>{this.generateList()}</ListGroup>
				<div style={buttonRowStyle}>
					<Link to="/home">
						<Button className="btn-secondary">CANCEL</Button>
					</Link>
					<GenModal
						buttonLabel="CAST BALLOT"
						buttonClass="btn-success"
						title="Confirmation"
						body="Selecting this option will submit your final ballot. You will not be able to return to this election. Continue?"
						yesPath="/home"
						yesFunc={this.props.castFinalBallot}
					/>
				</div>
			</div>
		);
	}
}

const boxStyle = {
	width: 'auto',
	height: 'auto',
	display: 'flex',
	flexDirection: 'column',
	border: '2px solid #000000',
	borderRadius: '8px',
	boxShadow: '0px 20px 40px rgba(0, 0, 0, 0.15)',
	background: '#602d89',
	'@media (max-width: 420px)': {
		marginTop: '0px',
	},
	'@media (min-width: 421px)': {
		marginTop: '2rem',
	},
	marginBottom: '4rem',
};

const titleStyle = {
	color: '#fff',
	padding: '14px 5px 0px 8px',
	fontFamily: 'Avenir',
	lineHeight: '1.4',
	'@media (max-width: 420px)': {
		fontSize: '20px',
	},
	'@media (min-width: 421px)': {
		fontSize: '24px',
	},
};

const itemStyle = {
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	cursor: 'pointer',
};

const iconBlockStyle = {
	display: 'flex',
	alignItems: 'center',
};

const buttonRowStyle = {
	padding: '10px 20px',
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
};

export default Radium(StatusList);
